import csrfHeaders from 'src/utils/csrfHeaders'
import { capitalize } from 'src/utils/inflections'
import { genericError } from '../fiat/useRecord'

const usePayment = ({
  i18n, partnerItem, donation, record, bankInfo, submitPath, finished, failed,
}) => {
  const sendPayment = async () => {
    record.setProcessing(true)

    try {
      // Wrap all processing in try to ensure finally is executed
      const payment_method_used = bankInfo.state.paymentOption == 'tbd'
        ? 'TBD' : capitalize(bankInfo.state.paymentOption)

      const { errors, token, serializedDonation } = await record.saveDraft({
        order: {
          bank_name:          bankInfo.state.bankName,
          last4:              bankInfo.state.last4,
          payment_source:     bankInfo.state.paymentOption,
          payment_method_used,
        }
      })
      if (errors) return failed(errors)

      const response = await fetch(submitPath, {
        method: 'POST',
        headers: csrfHeaders(),
        body: JSON.stringify({ order_id: token })
      })

      if (response.ok) {
        const { state, ...rest } = donation
        finished({
          ...state,
          ...rest,
          ...serializedDonation,
          token,
          partnerItem,
          afterThankYou: bankInfo.render,
        })
      } else {
        const json = await response.json()
        failed(json)
      }
    } catch (error) {
      console.error(error)
      failed(genericError(i18n))
    } finally {
      record.setProcessing(false)
    }
  }

  return { sendPayment }
}

export default usePayment
